import { render, staticRenderFns } from "./Materialinfo.vue?vue&type=template&id=396545e0&"
import script from "./Materialinfo.vue?vue&type=script&lang=js&"
export * from "./Materialinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports